import type { SelectItemProps, SelectProps } from '@radix-ui/react-select';
import type { FC, ReactNode } from 'react';
import * as RadixSelect from '@radix-ui/react-select';
import { Icon } from '@ui';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { SelectItem } from '@/ui/Select/components/SelectItem';
import styles from './Select.module.css';

type OptionType = {
    label: ReactNode;
    value: SelectItemProps['value'];
};

type Props = {
    error?: boolean;
    options: OptionType[];
    placeholder?: ReactNode;
    onChange?: SelectProps['onValueChange'];
} & Omit<SelectProps, 'onValueChange'>;

export const Select: FC<Props> = ({ error, options, placeholder, onChange, ...props }) => (
    <RadixSelect.Root onValueChange={onChange} {...props}>
        <RadixSelect.Trigger asChild className={clsx(styles.trigger, error && styles.error)}>
            <motion.button
                initial={{ scale: 1 }}
                whileHover={{ scale: (!props.disabled ? 1.01 : 1) }}
                whileTap={{ scale: 0.99 }}
                type="button"
            >
                <RadixSelect.Value placeholder={placeholder} />
                <RadixSelect.Icon asChild className={styles.icon}>
                    <Icon.ChevronDown size={24} />
                </RadixSelect.Icon>
            </motion.button>
        </RadixSelect.Trigger>
        <RadixSelect.Portal>
            <RadixSelect.Content asChild className={styles.content} position="popper" sideOffset={4}>
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'fit-content' }}
                >
                    <RadixSelect.Viewport className={styles.viewport}>
                        {options.map(({ label, value }) => (
                            <SelectItem key={value} value={value}>{label}</SelectItem>
                        ))}
                    </RadixSelect.Viewport>
                </motion.div>
            </RadixSelect.Content>
        </RadixSelect.Portal>
    </RadixSelect.Root>
);
